import RootShutterMixin from 'GroomyRoot/mixins/Shutter.js'

export default {
    mixins: [RootShutterMixin]
}
